import { useState } from "react";
import { clearToken, getToken } from "../services/tokenStorage";
import AdminDashboard from "./admin/AdminDashboard";
import AdminLogin from "./admin/AdminLogin";

function AdminPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(Boolean(getToken()));
  const [activeTab, setActiveTab] = useState("Prehled");

  const logout = () => {
    clearToken();
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <AdminLogin onAuthenticated={() => setIsAuthenticated(true)} />;
  }

  return <AdminDashboard activeTab={activeTab} onTabChange={setActiveTab} onLogout={logout} />;
}

export default AdminPage;
